import React, { useEffect } from 'react';

export interface YoutubeVideoProps {
  id: string;
  title: string;
}

const YoutubeVideo = ({ id, title }: YoutubeVideoProps) => {
  useEffect(() => {
    import('lite-youtube-embed');

    if (!document.getElementById('yt-iframe-api')) {
      const tag = document.createElement('script');
      tag.id = 'yt-iframe-api';
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }, []);

  return (
    <div className="mb-4 w-full h-full">
      <div className="relative bg-background [&>lite-youtube]:w-full [&>lite-youtube]:max-w-full lg:[&>lite-youtube]:overflow-hidden">
        <lite-youtube
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          frameBorder="0"
          title={title}
          videoid={id}
          params="rel=0&listType=playlist&loop=1&showinfo=0&iv_load_policy=30&start=0&end=0"
          js-api
        />
      </div>
    </div>
  );
};

export default YoutubeVideo;
